import {Observable} from 'rxjs';
import moment from 'moment-timezone';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Actions from './actions';

const getFetchObservable = (api, organizationId, month, refresh, options) =>
    api.fetchReport(organizationId, month, refresh, options);

const fetchReport = action$ =>
    action$.ofType(Actions.fetchReport.type).mergeMap(({payload}) => {
        let fetchObservable;

        if (payload.refresh) {
            fetchObservable = getFetchObservable(
                payload.api,
                payload.organizationId,
                payload.month,
                true,
                payload.options,
            ).mergeMap(({refreshRequestedAt}) => {
                return Observable.timer(0, 5000)
                    .mergeMap(() =>
                        getFetchObservable(payload.api, payload.organizationId, payload.month, false, payload.options),
                    )
                    .take(20)
                    .skipWhile(result => !moment(result.lastUpdatedAt).isAfter(refreshRequestedAt))
                    .take(1);
            });
        } else {
            fetchObservable = getFetchObservable(
                payload.api,
                payload.organizationId,
                payload.month,
                payload.refresh,
                payload.options,
            );
        }

        return fetchObservable
            .map(result => Actions.fetchReportSuccess.action(result))
            .catch(e => Observable.of(Actions.fetchReportFailed.action(e)));
    });

export default combineEpics(fetchReport);
